/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  Color,
  GetAllSystemColors200One,
  GetAllSystemColors200Three,
  GetAllSystemColors200Two,
  GetColorsParams
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetColorsUrl = (params?: GetColorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["colors"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Color/GetColors?${stringifiedParams}` : `/api/Color/GetColors`
}

export const getColors = async (params?: GetColorsParams, options?: RequestInit): Promise<Color[]> => {
  
  return customInstance<Color[]>(getGetColorsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetColorsQueryKey = (params?: GetColorsParams,) => {
    return [
    `/api/Color/GetColors`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetColorsQueryOptions = <TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(params?: GetColorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetColorsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getColors>>> = ({ signal }) => getColors(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetColorsQueryResult = NonNullable<Awaited<ReturnType<typeof getColors>>>
export type GetColorsQueryError = ErrorType<unknown>


export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params: undefined |  GetColorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getColors>>,
          TError,
          Awaited<ReturnType<typeof getColors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params?: GetColorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getColors>>,
          TError,
          Awaited<ReturnType<typeof getColors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params?: GetColorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params?: GetColorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetColorsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetColorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(params?: GetColorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetColorsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getColors>>> = ({ signal }) => getColors(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetColorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getColors>>>
export type GetColorsSuspenseQueryError = ErrorType<unknown>


export function useGetColorsSuspense<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params: undefined |  GetColorsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetColorsSuspense<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params?: GetColorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetColorsSuspense<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params?: GetColorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetColorsSuspense<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<unknown>>(
 params?: GetColorsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetColorsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAllSystemColorsUrl = () => {


  

  return `/api/Color/GetAllSystemColors`
}

export const getAllSystemColors = async ( options?: RequestInit): Promise<GetAllSystemColors200One | GetAllSystemColors200Two | GetAllSystemColors200Three> => {
  
  return customInstance<GetAllSystemColors200One | GetAllSystemColors200Two | GetAllSystemColors200Three>(getGetAllSystemColorsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAllSystemColorsQueryKey = () => {
    return [
    `/api/Color/GetAllSystemColors`
    ] as const;
    }

    
export const getGetAllSystemColorsQueryOptions = <TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllSystemColorsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSystemColors>>> = ({ signal }) => getAllSystemColors({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllSystemColorsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSystemColors>>>
export type GetAllSystemColorsQueryError = ErrorType<unknown>


export function useGetAllSystemColors<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSystemColors>>,
          TError,
          Awaited<ReturnType<typeof getAllSystemColors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSystemColors<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSystemColors>>,
          TError,
          Awaited<ReturnType<typeof getAllSystemColors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSystemColors<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllSystemColors<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllSystemColorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAllSystemColorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllSystemColorsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSystemColors>>> = ({ signal }) => getAllSystemColors({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllSystemColorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSystemColors>>>
export type GetAllSystemColorsSuspenseQueryError = ErrorType<unknown>


export function useGetAllSystemColorsSuspense<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSystemColorsSuspense<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSystemColorsSuspense<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllSystemColorsSuspense<TData = Awaited<ReturnType<typeof getAllSystemColors>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllSystemColors>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllSystemColorsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



